export const faqData = [
  {
    id: 1,
    question: 'What is Wayfinder AI?',
    answer:
      'Wayfinder AI is an intelligent blockchain navigation platform that empowers users with AI agents to seamlessly interact across multiple blockchain networks, simplifying complex on-chain operations.',
  },
  {
    id: 2,
    question: 'How does Wayfinder AI integrate AI with blockchain technology?',
    answer:
      'Wayfinder integrates AI through autonomous agents that understand natural language commands and execute blockchain transactions. These agents bridge the gap between complex blockchain operations and user-friendly interfaces.',
  },
  {
    id: 3,
    question: 'What are Wayfinder Shells?',
    answer:
      "Wayfinder Shells are autonomous AI agents in the Wayfinder AI ecosystem, designed to navigate and execute transactions across multiple blockchain networks. Users create these shells by minting them with the platform's native PROMPT token, granting exclusive ownership and control. They serve as customizable interfaces that respond to natural language commands, allowing non-technical users to perform complex on-chain tasks like token swaps, NFT minting, trading, or gaming automation.",
  },
  {
    id: 4,
    question: 'How do I create a Wayfinder Shell?',
    answer:
      "To create a Wayfinder Shell, you need to mint one using PROMPT tokens on the Wayfinder platform. Once minted, you gain exclusive ownership and can customize your shell's capabilities and responses to suit your specific needs.",
  },
  {
    id: 5,
    question: 'What are Wayfinding Paths in Wayfinder AI?',
    answer:
      'Wayfinding Paths are pre-configured workflows that guide users through complex blockchain operations. These paths provide step-by-step navigation for common tasks, making blockchain interactions more accessible and efficient.',
  },
  {
    id: 6,
    question: 'What is the PROMPT token?',
    answer:
      "PROMPT is the native utility token of the Wayfinder ecosystem. It serves as the primary currency for creating Wayfinder Shells, accessing premium features, and participating in the platform's governance and rewards system.",
  },
  {
    id: 7,
    question: 'What are the main uses of the PROMPT token?',
    answer:
      'PROMPT tokens are used for minting Wayfinder Shells, accessing premium AI features, participating in platform governance, staking for rewards, and paying for transaction fees within the Wayfinder ecosystem.',
  },
  {
    id: 8,
    question: 'What are the primary use cases for Wayfinder AI?',
    answer:
      'Primary use cases include DeFi operations, NFT trading and minting, cross-chain transactions, automated trading strategies, gaming automation, portfolio management, and educational blockchain exploration for newcomers.',
  },
  {
    id: 9,
    question: 'How does Wayfinder ensure the security of AI agents and paths?',
    answer:
      'Wayfinder implements multiple security layers including smart contract audits, encrypted communication protocols, permission-based access controls, and continuous monitoring to ensure all AI agents and paths operate securely and transparently.',
  },
  {
    id: 10,
    question: 'What blockchains does Wayfinder initially focus on?',
    answer:
      'Wayfinder initially focuses on major EVM-compatible blockchains including Ethereum, Polygon, Arbitrum, and Optimism, with plans to expand to additional networks based on community demand and strategic partnerships.',
  },
];
